import React, { useState } from "react";
import {
  Text,
  StyleSheet,
  View,
  Platform,
  TouchableOpacity,
} from "react-native";

import cardStyles from "../cardStyles";
import ListIcon from "../../../common/ActionsMenuButton/icons/ListIcon";
import InsightsIcon from "../../../common/ActionsMenuButton/icons/InsightsIcon";
import AppTheme from "../../../AppTheme";
import ViewModes from "../../../reflection/header/viewModes";
import CloseIcon from '../../../common/dialog/CloseIcon';

export default function ReflectionViewSettingsCard({
  changeViewMode = () => {},
}) {
  const [showCard, setShowCard] = useState(true);

  // ------------------------------------- RENDER -------------------------------------
  return !showCard ? null : (
    <View style={cardStyles.container}>
      <View
        style={[
          cardStyles.card,
          { minHeight: 98, height: "auto", paddingBottom: 8, paddingTop: 0 },
        ]}
      >
        <CloseIcon
          onPress={() => setShowCard(false)}
          style={cardStyles.closeButton}
        />

        {/* Title */}
        <View style={[cardStyles.header, { paddingHorizontal: 0 }]}>
          <View style={[cardStyles.headerInfo]}>
            <Text style={cardStyles.title}>Reflection View Settings</Text>
          </View>
        </View>

        <Text style={styles.text}>
          Switch between views that display insights on your top Elements (this
          screen) or raw hour counts for all Elements by using the icons at the
          top of the screen
        </Text>

        <View style={{ flexDirection: "row", marginTop: 8 }}>
          <TouchableOpacity
            style={[styles.button, { marginRight: 16 }]}
            onPress={() => setShowCard(false)}
          >
            <Text style={styles.buttonText}>Stay on Insights View</Text>
            <InsightsIcon />
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.button}
            onPress={() => changeViewMode(ViewModes.tableView)}
          >
            <Text style={styles.buttonText}>Take me to hours view</Text>
            <ListIcon fillColor={AppTheme.DEFAULT_COLOR} />
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  text: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  button: {
    backgroundColor: "#F3F2F1",
    borderRadius: 4,
    alignItems: "center",
    paddingTop: 6,
    paddingBottom: 8,
    flex: 1,
    height: 58,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 10,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#8B92A1",
  },
});
